<template>
  <div class="signin_page modal_card">
    <div class="signin_form modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Восстановление доступа</h1>
      <form @submit.prevent="reset">
        <b-field
          label="Логин:"
          type="is-info"
          class="email_input has_icon"
          :message="errors.first('email')"
          :class="errors.has('email') ? 'error' : ''"
        >
          <b-input
            v-validate="{ required: true }"
            name="email"
            placeholder="Логин"
            v-model="email"
            icon="mdi mdi-email"
          ></b-input>
        </b-field>
        <p class="info_text">
          На ваш электронный адрес или адрес вашего куратора <br />
          будет отправлено письмо с новым паролем
        </p>
        <button class="signin_button" type="submit" :disabled="errors.items.length > 0">Восстановить доступ</button>
      </form>
    </div>
  </div>
</template>

<script>
import { toastInfo } from '@/lib/toastCfg'

export default {
  data() {
    return {
      email: '',
      validationPassed: false,
      dict: {
        custom: {
          email: {
            required: 'Поле не заполнено',
            email: 'Неверный формат',
            regex: 'Логин должен состоять из латинских букв'
          }
        }
      }
    }
  },
  methods: {
    reset() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$axios2
            .post('reset_password', { email: this.email })
            .then(() => {
              this.$emit('close-modal')
              this.$buefy.toast.open(toastInfo())
            })
            .catch(this.$errorToast)
        }
      })
    }
  },
  created() {
    this.$validator.localize('ru', this.dict)
  }
}
</script>
